import { UnsuccessfulCustomEventSchema } from "components/Layout/CustomEvent/SchemaImportList/CustomEventSchemaImportList";
import { UnsuccessfulImportedWalletData } from "components/Layout/WalletType/WalletTypeImportList/WalletTypeImportList";
import {
  ImportedAchievement,
  UnSuccessfulImportedAchievementData,
} from "types/achievements";
import {
  CampaignBEData,
  UnSuccessfulImportedCampaignData,
} from "types/campaigns";
import { ImportedCustomEventSchema } from "types/customEvents";
import { RewardFieldsBE, UnsuccessfullReward } from "types/rewards";
import { BEWalletTypeFormat } from "types/wallets";
import { Imported } from "./ConfigImportList";
import { Tab } from "./Tabs/Tabs";

export type ImportResults = {
  [Tab.WALLET]?: {
    saved: BEWalletTypeFormat[];
    unsaved: UnsuccessfulImportedWalletData[];
  };
  [Tab.REWARDS]?: {
    saved: RewardFieldsBE[];
    unsaved: UnsuccessfullReward[];
  };
  [Tab.CUSTOM_EVENT]?: {
    saved: ImportedCustomEventSchema[];
    unsaved: UnsuccessfulCustomEventSchema[];
  };
  [Tab.ACHIEVEMENTS]?: {
    saved: ImportedAchievement[];
    unsaved: UnSuccessfulImportedAchievementData[];
  };
  [Tab.CAMPAIGNS]?: {
    saved: CampaignBEData[];
    unsaved: UnSuccessfulImportedCampaignData[];
  };
  [Tab.REFERRALS]?: {
    saved: CampaignBEData[];
    unsaved: UnSuccessfulImportedCampaignData[];
  };
  [Tab.AUTOMATIONS]?: {
    saved: CampaignBEData[];
    unsaved: UnSuccessfulImportedCampaignData[];
  };
};

export const isAnyTableValue = (successfullImport: Imported) => {
  return Object.keys(successfullImport).some((tab) => {
    const tableValues =
      successfullImport[tab as keyof typeof successfullImport];

    if (Array.isArray(tableValues) && tableValues.length > 0) return true;

    return false;
  });
};
